import type { SVGProps } from 'react';

const SvgPlayerTimeFormat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M14 5.26V5h1c.55 0 1-.45 1-1s-.45-1-1-1H9c-.55 0-1 .45-1 1s.45 1 1 1h1v.26C6.56 6.15 4 9.28 4 13c0 4.41 3.59 8 8 8s8-3.59 8-8c0-3.72-2.56-6.85-6-7.74M12 19c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6"
    />
    <path
      fill="currentcolor"
      d="M13 12.59V10c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .27.11.52.29.71l2 2c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41zm5.36-4.54c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-1.41-1.41a.996.996 0 1 0-1.41 1.41l1.41 1.41z"
    />
  </svg>
);
export default SvgPlayerTimeFormat;
